import React from 'react';
import { withLoadingAndNoConnectionHandler } from '../../../integration-wrapper';
import { AdditionalServicesDetailsUi } from './ui';
import { Contract } from '@cp-mx/common';
import { useAdditionalServices } from '../../useContract';

const AdditionalServicesDetailsWithHandlers = withLoadingAndNoConnectionHandler(AdditionalServicesDetailsUi);

export const AdditionalServicesDetails: React.FC<{ contract: Contract; title?: string }> = ({ contract, title }) => {
    const { data: additionalServicesDetails, isLoading } = useAdditionalServices();
    return (
        <AdditionalServicesDetailsWithHandlers
            isLoading={isLoading}
            additionalServicesDetails={additionalServicesDetails}
            contractLabel={contract.contractLabel}
            title={title}
            hasError={false}
            component="additional-services-details"
        />
    );
};
